import { accountantIbkApi, clientIbkApi } from '@ibk/shared-config';
export const buildSearchBeneficiariesQuery = ({ contractId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/beneficiaries/search`,
    method: 'POST',
    body,
});
export const transformSearchBeneficiariesResponse = (response, meta) => {
    const result = response.result ?? [];
    const totalHeader = meta?.response?.headers?.get('X-Total-Count');
    const total = totalHeader !== null && totalHeader !== undefined ? Number(totalHeader) : result.length;
    return { result, total: Number.isNaN(total) ? result.length : total };
};
export const buildBeneficiaryFiltersQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/beneficiaries/filters`,
    method: 'GET',
});
export const transformBeneficiaryFiltersResponse = (response) => response.result;
export const buildBusinessDaysQuery = ({ competence }) => ({
    url: '/v1/benefits/orders/business-days',
    method: 'GET',
    params: competence ? { competence } : {},
});
export const transformBusinessDaysResponse = (response) => response.result?.businessDays ?? 0;
export const buildUpdateBeneficiaryMutation = ({ contractId, beneficiaryId, body, }) => ({
    url: `/v1/benefits/contracts/${contractId}/beneficiaries/${beneficiaryId}`,
    method: 'PATCH',
    body,
});
export const accountantContractBeneficiariesApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        searchAccountantEmissorContractBeneficiaries: build.query({
            query: buildSearchBeneficiariesQuery,
            transformResponse: transformSearchBeneficiariesResponse,
        }),
        getAccountantEmissorBeneficiaryFilters: build.query({
            query: buildBeneficiaryFiltersQuery,
            transformResponse: transformBeneficiaryFiltersResponse,
        }),
        getAccountantEmissorBusinessDays: build.query({
            query: buildBusinessDaysQuery,
            transformResponse: transformBusinessDaysResponse,
        }),
        updateAccountantEmissorContractBeneficiary: build.mutation({
            query: buildUpdateBeneficiaryMutation,
        }),
    }),
    overrideExisting: false,
});
export const clientContractBeneficiariesApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        searchClientEmissorContractBeneficiaries: build.query({
            query: buildSearchBeneficiariesQuery,
            transformResponse: transformSearchBeneficiariesResponse,
        }),
        getClientEmissorBeneficiaryFilters: build.query({
            query: buildBeneficiaryFiltersQuery,
            transformResponse: transformBeneficiaryFiltersResponse,
        }),
        getClientEmissorBusinessDays: build.query({
            query: buildBusinessDaysQuery,
            transformResponse: transformBusinessDaysResponse,
        }),
        updateClientEmissorContractBeneficiary: build.mutation({
            query: buildUpdateBeneficiaryMutation,
        }),
    }),
    overrideExisting: false,
});
export const { useLazySearchAccountantEmissorContractBeneficiariesQuery, useGetAccountantEmissorBeneficiaryFiltersQuery, useGetAccountantEmissorBusinessDaysQuery, useUpdateAccountantEmissorContractBeneficiaryMutation, } = accountantContractBeneficiariesApi;
export const { useLazySearchClientEmissorContractBeneficiariesQuery, useGetClientEmissorBeneficiaryFiltersQuery, useGetClientEmissorBusinessDaysQuery, useUpdateClientEmissorContractBeneficiaryMutation, } = clientContractBeneficiariesApi;
